import { SEARCH_SUGGESTIONS_SERVICE_URL } from '~/modules/config';
import { handleException } from '~/modules/utilities/error_utilities';
import { http } from '~/modules/utilities/http';

export interface TopSearchesResult {
    searches: string[];
}

const getTopSearchesEndpoint = (): string => {
    return `${SEARCH_SUGGESTIONS_SERVICE_URL}/v1/topsearches`;
};

const getTopSearches = async (): Promise<TopSearchesResult> => {
    try {
        const response = await http.get(getTopSearchesEndpoint());
        return response.data as TopSearchesResult;
    } catch (error) {
        handleException(error, 'topSearchesService.getTopSearches');
        return { searches: [] };
    }
};

export { getTopSearches };
